export default __webpack_public_path__ + "static/media/jo.6d45f2e5.svg";